import { popoverClasses } from '@mui/material';
/**
 * Component overrides (i.e. global styles, default props) applied to
 * MuiPopover to make it match the design system.
 *
 * See: https://mui.com/material-ui/api/popover/#css
 */ export const MuiPopover = {
    defaultProps: {
        // Fix accessibility violation: prevent aria-hidden on backdrop
        // so that focusable menu items inside don't violate WCAG guidelines
        componentsProps: {
            backdrop: {
                'aria-hidden': false
            }
        }
    },
    styleOverrides: {
        root: ({ theme })=>({
                borderRadius: theme.shape.borderRadius,
                [`& .${popoverClasses.paper}`]: {
                    backgroundColor: theme.palette.background.popover
                }
            })
    }
};

//# sourceMappingURL=popover-overrides.js.map